// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "code[data-v-2b9534ee] {\n  color: white;\n}\na[data-v-2b9534ee] {\n  color: white;\n  text-decoration: underline;\n}\n.disclaimer[data-v-2b9534ee] {\n  font-size: 12px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
